import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowbiteIconComponent } from '@app/common/components/flowbite/flowbite-icon/flowbite-icon.component';

@Component({
  selector: 'app-flowbite-button',
  templateUrl: './flowbite-button.component.html',
  styleUrl: './flowbite-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FlowbiteIconComponent],
  standalone: true,
})
export class FlowbiteButtonComponent {
  @Output() buttonClick = new EventEmitter<MouseEvent>();
  @Input() iconName = '';
  @Input() iconStyle = '';
  @Input() size = 'md';
  @Input() color = '';
  @Input() disabled = false;
  @Input() type = 'button';
  @Input() outline = false;

  getSizeClass(): string {
    switch (this.size) {
      case 'lg':
        return 'text-sm px-5 py-3 min-w-36';
      case 'sm':
        return 'text-xs px-3 py-2 min-w-20';
      case 'xs':
        return 'text-xs px-2 py-1';
      default:
        return 'text-sm px-5 py-2.5 min-w-32';
    }
  }

  getColorClass(): string {
    if (this.color === 'light' && !this.outline) {
      return 'text-gray-900 bg-white border border-gray-300 hover:bg-gray-100 focus:ring-blue-300';
    }
    if (this.color === 'light' && this.outline) {
      return 'text-gray-900 bg-white border border-gray-900 hover:bg-gray-100 focus:ring-blue-300';
    }
    if (this.color === 'red' && !this.outline) {
      return 'text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300';
    }
    if (this.color === 'red' && this.outline) {
      return 'text-red-700 border border-red-700 hover:text-white hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300';
    }
    if (this.color === 'green' && this.outline) {
      return 'text-green-700 border border-green-700 hover:text-white  hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300';
    }
    if (this.color === '' && this.outline) {
      return 'text-blue-700 border border-blue-700 hover:bg-blue-800 hover:text-white focus:ring-blue-300';
    } else {
      return 'text-white bg-blue-700 hover:bg-blue-800 focus:ring-blue-300';
    }
  }
}
